import { Component, HostBinding, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-form-field-wrapper',
  standalone: true,
  imports: [NgClass, NgIf, TooltipModule],
  templateUrl: './form-field-wrapper.component.html',
  styleUrl: './form-field-wrapper.component.scss',
})
export class FormFieldWrapperComponent {
  @Input() colSize?: number | string = 12;
  @Input() label? = '';
  @Input() help? = '';
  @Input() warning? = '';
  @Input() name? = '';
  @Input() icon? = '';
  @Input() floatingLabel = true;
  @Input() hideLabel = false;
  @Input() tooltip? = '';
  @Input() formField: AbstractControl | null = null;
  @Input() styleClass = '';

  @HostBinding('class') get columnClass(): string {
    if (this.colSize === undefined) return '';
    return this.colSize !== 0 ? `col-${this.colSize}` : 'col';
  }
}
